import { render } from "./BooleanField.vue?vue&type=template&id=34965e70&scoped=true&ts=true"
import script from "./BooleanField.vue?vue&type=script&lang=ts"
export * from "./BooleanField.vue?vue&type=script&lang=ts"

import "./BooleanField.vue?vue&type=style&index=0&id=34965e70&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34965e70"]])

export default __exports__